export default {
  getAbsences: (state) => state.absences.data,
  getAbsencesDates: (state) => ["جميع التواريخ المتاحة", ...state.dates],
  getAbsencesReasons: (state) => state.reasons,
  getAbsencesPagination: (state) => state.absences.pagination,
};
